import { Eyebrow } from "@/components/site/Motion";
import { ScrollWords } from "@/components/site/ScrollWords";

const TEXT = "We were never the biggest name on anyone's list. Fine by us. While the big desks sent PowerPoints, we sent people. Good ones, ready by Monday, still smiling on Friday. That habit never left. It's why your call gets picked up, your shortlist turns up when we said it would, and nobody here is ever 'checking with the team'.";

export const Manifesto = () => (
  <section className="grain grain-dark relative bg-[#0E0E10] px-5 py-28 sm:px-8 lg:py-44" data-testid="manifesto-section">
    <div className="relative mx-auto grid max-w-[1400px] gap-10 lg:grid-cols-12">
      <div className="lg:col-span-3">
        <Eyebrow className="text-[#FF4D1A]">why we move like this</Eyebrow>
      </div>
      <ScrollWords text={TEXT} highlight={["people.", "Good", "Monday,", "picked"]}
        className="font-display text-2xl font-semibold leading-[1.25] tracking-[-0.02em] sm:text-4xl lg:col-span-9 lg:text-[2.75rem]" />
    </div>
  </section>
);
